<template>
    <div style="width:100%;float:left;">
      <CCard>
        <CCardHeader>Retry Job</CCardHeader>
        <CCardBody>
            <div class="col-12">
              <div style="width:320px;text-align:center;margin-left:auto;margin-right:auto;">
                <input type="search" placeholder="Type in a job ID that you would like to retry." class="form-control float-left searchInput" @keyup.enter="submitJob()" style="width:250px;" v-model="job_id" />
                <CButton size="sm" color="info" class="searchButton" @click="submitJob()">Submit</CButton>
              </div>
            </div>
        </CCardBody>
      </CCard>
    </div>
  </template>
  <script>

  var methods = {}

  methods.submitJob = function () {
    const postData = {
      job_id: this.job_id
    }
    axios.post(this.$apiAdress + '/api/retryJob?token=' + localStorage.getItem('api_token'), postData).then(response => {
      console.log(response)
      Swal.fire("Submitted.", "You have submitted the job id #" + this.job_id, "success")
      this.job_id = ''
    })
  }
  
  export default {
    // ===Component name
    name: "RetryJob",
    // ===Props passed to component
    props: {},
    // ===Components used by this component
    components: {
  
    },
    // ====component Data properties
    data(){
        return{
          job_id: ''
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
  
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
  }
  </script>
  <!-- styles -->
  <!-- adding scoped attribute will apply the css to this component only -->
  <style scoped></style>
  